import React, { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import {
  Form,
  Row,
  Button,
  message,
  Tabs,
  Radio,
  Input,
  Alert,
} from "antd";
import { sendGrade, getNoticeDetail } from "./api";
import { judgeIsLogin } from "../../common/utils";
import Logo from "../../assets/images/qingcloud_new.svg";
import "./index.less";
import WangEditor from "../../components/WangEditor";

const { TabPane } = Tabs;
const { TextArea } = Input;

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 18 },
};

const tailLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 24 },
};

const editorMenus = [
  'head',
  'bold',
  'fontSize',
  'fontName',
  'italic',
  'underline',
  'strikeThrough',
  'indent',
  'lineHeight',
  'foreColor',
  'backColor',
  'todo',
  'justify',
  'splitLine',
  'undo',
  'redo',
]

function ExamResultEmailNotice() {
  const history = useHistory();
  const urlParams: { id: string, type:string } = useParams();
  const userinfo =
    JSON.parse(localStorage.getItem("userinfo") || JSON.stringify({})) || {};

  const [emailContent,setEmailContent]=useState('');
  const [flag,setFlag]=useState(false);
  const [disabled,setDisabled]=useState(false);
  const [initData,setInitData]=useState<any>({})
  const ref = useRef<any>();
  
  
  useEffect(() => {
    if (!userinfo.id) {
      judgeIsLogin();
    }else{
      if(urlParams.type==='view'){
        setDisabled(true);
        getNoticeDetail({
          id:urlParams.id
        }).then((res: any) => {
          if (res && res.code === 0) {
            setInitData(res.data || {})
            // message.success(res.msg || '提交成功');
          } else {
            res && message.error(res.msg);
          }
        });
      }
    }
  }, []);

  const goHome = () => {
    history.push("/");
  };

  
 
  const handleFormFinishFailed = (errors: any) => {
    setFlag(true);
    message.error("请完善信息！");
  };

  const handleFormFinish = (values: any) => {
    setFlag(true);
    console.log('emailContent',emailContent)
    if(!emailContent){
      message.error("请完善信息！");
      return;
    }
    let params = {
      notice:{
        ...values,
        content:emailContent,
      },
      examID:urlParams.id,
      userID:userinfo.id
    };
    sendGrade(params).then((res: any) => {
      if (res && res.code === 0) {
        message.success(res.msg || '提交成功');
      } else {
        res && message.error(res.msg);
      }
    });
  };

  const handleBlurEditor = (data:any)=>{
    setFlag(true);
    setEmailContent(data);
  }

  const checkSendTo = (data:any)=>{
    const formData = ref?.current?.getFieldsValue();
    const reg = /^((([a-z0-9_.-]+)@([\da-z.-]+).([a-z.]{2,6},))*(([a-z0-9_.-]+)@([\da-z.-]+).([a-z.]{2,6})))$/;
    const flag = reg.test(formData.sendTo)
    if(!formData.sendTo) {
      return Promise.resolve()
    }
    if (!flag) {
      return Promise.reject('请输入正确的邮箱格式，多邮箱使用英文逗号‘,’分隔')
    }
    // 通过验证
    return Promise.resolve()
  }

  return (
    <>
      <div className="exam-before">
        <div className="exam-before-head">
          <div className="head">
            <div className="head-left">
              <div className="logo" onClick={goHome}>
                <img src={Logo} alt="青云" />
                <span className="line">|</span>
                <span className="text">合作伙伴支持平台</span>
              </div>
            </div>
            <div className="head-right">{userinfo.employee_name}</div>
          </div>
        </div>
        <div className="exam-before-content exam-evn-feedback-content">
          <div className="content">
            <div className="detail_basic">
              <Tabs defaultActiveKey="1">
                <TabPane tab="邮件通知考试结果" key="1">
                  <Row
                    style={{
                      marginTop: 20,
                      marginBottom: 20,
                      height: "100%",
                      overflow: "auto",
                    }}
                  >
                    <Form
                      {...layout}
                      style={{ width: "100%" }}
                      name="basic"
                      className="exam-result-email-notice"
                      onFinish={handleFormFinish}
                      onFinishFailed={handleFormFinishFailed}
                      key={initData.id}
                      ref={ref}
                    >
                      <Form.Item
                        label="邮件接收者"
                        name="sendTo"
                        rules={[{ required: true, message: '请输入邮件接收者' },{ validator: checkSendTo }]}>
                          <Input defaultValue={initData.send_to} disabled={disabled} placeholder="请输入邮件接收者,多个邮箱使用英文逗号‘,’进行分隔"  allowClear  />
                      </Form.Item>
                      <Form.Item
                        label="邮件标题"
                        name="title"
                        rules={[{ required: true, message: '请输入邮件标题' }]}>
                        <Input defaultValue={initData.title} disabled={disabled} placeholder="请输入邮件标题" allowClear />
                      </Form.Item>
                      <Alert
                        message="邮件内容样例"
                        showIcon
                        description={<>
                        <div  className='email-eg-item'>
                          <span>【样例】</span>
                          <p dangerouslySetInnerHTML={{__html:'您好：<br/> 学员{userName}，{userEmail}参加《{title}》考试结果如下</br>考试分数:{grade}<br>考试状态:{isPass}'}}></p>
                          <div>
                            <span>
                              userName:学员姓、
                            </span>
                            <span>
                              userEmail:学员邮箱、
                            </span>
                            <span>
                              title:考试标题、
                            </span>
                            <span>
                            grade:分数、
                            </span>
                            <span>
                            isPass:是否及格
                            </span>
                          </div>
                        </div>
                        </>}
                        type="warning"
                        className='email-config-content-exp'
                      />
                      <Form.Item
                        label="邮件内容"
                        name="content"
                        className='email-item'
                        key={String(disabled)}
                        >
                            <WangEditor  
                              menus={editorMenus}  
                              onBlurEditor={handleBlurEditor}
                              disabled={disabled}
                              initData={initData.content}
                            />

                            {
                              !emailContent && flag &&
                              <div className="errMsg">请输入邮件内容</div>
                            }
                      </Form.Item>
                      {
                        urlParams.type!=='view' &&
                        <Form.Item  {...tailLayout}>
                        <div className="btn-group">
                          <Button type="primary" htmlType="submit">
                            提交
                          </Button>
                        </div>
                        </Form.Item>
                      }
                    </Form>
                  </Row>
                </TabPane>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ExamResultEmailNotice;
